var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{on:{"click":_vm.run}},[_vm._t("default",null,{"isLoading":_vm.isLoading,"result":_vm.result,"error":_vm.error})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }